<div class="db-new-version-tab">
  <div class="db-new-version-tag">
    <span>New Version</span>
  </div>
  <h3>New Update Available</h3>
  <p>Please download and install <br> the following file to access <br>the latest version of 10Web Booster.</p>
  <a [ngClass]="{'disabled': loading}" class="db-link" (click)="downloadBoosterPlugin()">
    <span>Download the Plugin</span>
  </a>
</div>
